const middleware = {}

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['checkAuth'] = require('../middleware/checkAuth.js')
middleware['checkAuth'] = middleware['checkAuth'].default || middleware['checkAuth']

middleware['registerPage'] = require('../middleware/registerPage.js')
middleware['registerPage'] = middleware['registerPage'].default || middleware['registerPage']

export default middleware
